const notificationTypes = ['LOAD_NOTIFICATIONS', 'LOAD_NOTIFICATION_TYPES', 'LOAD_NOTIFICATION_PREFERENCES'];

export default notificationTypes;
